import httpClient from "./httpClient";

const COTATION_BY_ID = "/cotations/";
const COTATION_SELLER_FILTERS = "/dropdowns/active-sellers";

function fetchCotationsByPage(page, pageSize, entityId, idInstance) {
    const COTATION_BY_PAGE = `/cotations/entity=${entityId || -1}?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(COTATION_BY_PAGE + page + '&descending=true');
}

function fetchCotationsByPageOrderBy(page, orderBy, search, pageSize, entityId, idInstance) {
    const COTATION_BY_PAGE = `/cotations/entity=${entityId}?idInstance=${idInstance}&pageSize=${pageSize}&page=`;
    return httpClient.get(COTATION_BY_PAGE + page + orderBy + search + '&descending=true');
}

function fetchCotationsById(id) {
    return httpClient.get(COTATION_BY_ID + id);
}

function fetchCotationsSellersFilters() {
    return httpClient.get(COTATION_SELLER_FILTERS);
}

export { fetchCotationsByPage, fetchCotationsByPageOrderBy, fetchCotationsById, fetchCotationsSellersFilters };
